import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';

/**
 * Hook for binning and sorting data
 * @param {*} jobs
 * @returns
 */
const useBins = ({ openJobs, closedJobs }) => {
  const [sortedOpenBins, setSortedOpenBins] = useState([]);
  const [sortedClosedFilledBins, setClosedFilledBins] = useState([]);
  const [
    sortedApplicantsInterviesOffersBins,
    setApplicantsInterviesOffersBins,
  ] = useState([]);

  useEffect(() => {
    // Counts each open job attribute that are recorded
    // during a specific month and yaer combination
    if (Array.isArray(openJobs) && openJobs.length !== 0) {
      const bins = [];
      const openBins = {};
      const sortedJobs = Object.values(openJobs)
        .filter((job) => !_.isEmpty(job))
        .sort((a, b) => b.postingDate - a.postingDate)
        .reverse();
      const jobsLength = sortedJobs.length;

      for (let i = 0; i < jobsLength; i += 1) {
        const job = sortedJobs[i];

        const { postingDate } = job;
        const jobDate = new Date(postingDate);
        const binDate = `${jobDate.getFullYear()}-${jobDate.getMonth() + 1}-15`;
        const date = new Date(binDate);
        if (!bins.includes(binDate)) {
          bins.push(binDate);
          openBins[binDate] = { Open: 1, date };
        } else {
          openBins[binDate].Open += 1;
        }
      }

      if (openBins.length !== 0) {
        setSortedOpenBins(Object.values(openBins));
      }
    }
  }, [openJobs]);

  useEffect(() => {
    // Counts each closed job attribute that are recorded
    // during a specific month and yaer combination
    if (Array.isArray(closedJobs) && closedJobs.length !== 0) {
      const bins = [];
      const closedFilledBins = {};
      const applicantsInterviesOffersBins = {};
      const sortedJobs = Object.values(closedJobs)
        .filter((job) => !_.isEmpty(job))
        .sort((a, b) => b.closedFilledDate - a.closedFilledDate)
        .reverse();
      const jobsLength = sortedJobs.length;

      for (let i = 0; i < jobsLength; i += 1) {
        const job = sortedJobs[i];
        const {
          closedFilledDate,
          closedFilled,
          numberApplicants,
          numberApplicantsInterviewed,
          numberOffersMade,
        } = job;
        const jobDate = new Date(closedFilledDate);
        const binDate = `${jobDate.getFullYear()}-${jobDate.getMonth() + 1}-15`;
        const filled = closedFilled === 'Filled' ? 1.0 : 0.0;
        const closed = closedFilled === 'Closed' ? 1.0 : 0.0;
        const date = new Date(binDate);

        if (!bins.includes(binDate)) {
          bins.push(binDate);
          closedFilledBins[binDate] = {
            Closed: closed,
            Filled: filled,
            date,
          };
          applicantsInterviesOffersBins[binDate] = {
            Applicants: numberApplicants,
            Interviews: numberApplicantsInterviewed,
            Offers: numberOffersMade,
            date,
          };
        } else {
          closedFilledBins[binDate].Filled += filled;
          closedFilledBins[binDate].Closed += closed;

          applicantsInterviesOffersBins[binDate].Applicants += numberApplicants;
          applicantsInterviesOffersBins[binDate].Interviews +=
            numberApplicantsInterviewed;
          applicantsInterviesOffersBins[binDate].Offers += numberOffersMade;
        }
      }

      if (closedFilledBins.length !== 0) {
        setClosedFilledBins(Object.values(closedFilledBins));
      }

      if (applicantsInterviesOffersBins.length !== 0) {
        setApplicantsInterviesOffersBins(
          Object.values(applicantsInterviesOffersBins)
        );
      }
    }
  }, [closedJobs]);

  return useMemo(() => {
    return {
      sortedOpenBins,
      sortedClosedFilledBins,
      sortedApplicantsInterviesOffersBins,
    };
  }, [
    sortedOpenBins,
    sortedClosedFilledBins,
    sortedApplicantsInterviesOffersBins,
  ]);
};

export default useBins;
